<div *ngIf="showSearchBar()">
    <app-item-finder-search-bar #item_finder_search_component [selectedNode]="this.selectedNode"></app-item-finder-search-bar>
</div>

<div *ngIf="!this.loading">
    <app-disclaimer-item-finder [selectedNode]="this.selectedNode"></app-disclaimer-item-finder>
</div>

<div *ngIf="showArrayModel()">
    <app-item-finder-array-model [selectedNode]="this.selectedNode" [doAction]="this.doAction"
        [itemFinderDoubleClick]="this.itemFinderDoubleClick"></app-item-finder-array-model>
</div>

<div *ngIf="showTreeModel()">
    <app-item-finder-tree-model [selectedNode]="this.selectedNode"
        [doAction]="this.doAction"></app-item-finder-tree-model>
</div>

<div *ngIf="this.loading" style="padding-top: 300px;">
    <app-loading />
</div>